import { PaymentTransactionStatus } from '../../services/models/PaymentTransactionStatus';
import { PaymentEntryType } from '../../services/models/PaymentEntryType';
import { PaymentDetails } from '../../services/models/PaymentDetails';
import P2C2P from './2c2p/2c2p';

export async function authorizePayment(paymentObject: PaymentDetails, closeModal?: boolean, redirectUrl?: string) {
  //find the transaction with status required authorize
  //TODO in future, some initiated transaction may be no need do authorize (QR code, etc)
  const transactionRequiredAuth = paymentObject.transactions.find(
    (transaction) => transaction.status == PaymentTransactionStatus.Initiated,
  );
  if (transactionRequiredAuth) {
    const entry = transactionRequiredAuth.entries.find((entry) => entry.entryType == PaymentEntryType.Initiate);
    //TODO depends on provider, we need to load different components, on hold until get 2rd provider sdk.
    const directPaymentUrl = entry?.payload?.directPaymentUrl;
    if (directPaymentUrl && directPaymentUrl != '') {
      window.location.href = directPaymentUrl;
    } else {
      // Here to decide the dynamic gateway handling
      return await P2C2P.authorizePaymentWithComponent(
        entry,
        paymentObject.paymentId,
        transactionRequiredAuth.transactionId,
        paymentObject?.refType,
        closeModal,
        redirectUrl,
      );
    }
  }
  return new Promise<void>((resolve) => resolve());
}
